import { Injectable } from '@angular/core';
import { AgeRendererComponent } from '../covance-ag-grid/renderers/age-renderer/age-renderer.component';
import { CovanceGridColumn, LinkParams, LinkAgRendererComponent, MulticellTooltip, MulticellItem, MulticellParams, MulticellAgRendererComponent } from '../covance-ag-grid';
import { comparators } from '../core';
import { ExternalUserEQuery } from './models/external-user-e-query';

@Injectable()
export class EQueriesColumns {
    public ageColumn(): CovanceGridColumn {
        return {
            headerName: 'eQuery Age',
            field: 'eQueryAge',
            width: 70,
            cellRendererFramework: AgeRendererComponent,
            comparator: comparators.distanceComparator,
            filterValueGetter: (params: { data: ExternalUserEQuery } ) => params.data.eQueryAge.formattedValue
        };
    }

    public eQueryIdColumn<TData extends DataWithEQuery>(
        buildRouterLink: (params: EQueryNumberRendererParams<TData>) => string | any[]
    ): CovanceGridColumn {
        return {
            headerName: 'eQueryId',
            field: 'eQueryId',
            width: 95,
            valueGetter: (params: EQueryNumberRendererParams<TData>) => {
                if (!params.data) {
                    return null;
                }

                const textedEQueryId = params.data.eQueryId ? params.data.eQueryId.toString() : '';

                const routerLink: LinkParams = {
                    routerLink: buildRouterLink(params),
                    preserveQueryParams: true,
                    text: textedEQueryId,
                    linkIcon: 'search',
                    toString: () => textedEQueryId
                };

                return routerLink;
            },
            comparator: comparators.linkNumberParamsComparator,
            cellRendererFramework: LinkAgRendererComponent,
        };
    }

    public responders(): CovanceGridColumn {
        return {
            headerName: 'Responders',
            field: 'responders',
            width: 70,
            comparator: (a, b) => comparators.mixedStringComparator(a, b),
            valueGetter: (params: {data: {responders: string[]}}) => {
                if (!params.data) {
                    return '';
                }
                const tooltips = params.data.responders.map<MulticellTooltip>(v => {
                    return {
                        content: v
                    };
                });
                const items: MulticellItem[] = [{
                    displayValue: params.data.responders[0],
                    tooltips: tooltips
                }];
                return {
                    alwaysShowTooltip: true,
                    items: items,
                    toString: () => items.map(i => i.displayValue).join('\n')
                } as MulticellParams;
            },
            cellRendererFramework: MulticellAgRendererComponent
        };
    }
}

interface DataWithEQuery {
    eQueryId: number;
}

interface EQueryNumberRendererParams<TData> {
    data: TData;
}
